module.exports = __webpack_public_path__ + "img/4.ac0f6643.jpg";